import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import StoreTitle from "../../component/StoreTitle";

const InventoryHero = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ padding: 3 }}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate("/dashboard")}
        sx={{ marginBottom: 3 }}
      >
        Back
      </Button>
      <Box sx={{ marginTop: -8 }}>
        <StoreTitle title="Inventory Management" />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          marginBottom: 4,
          gap: 2,
        }}
      >
        <Button variant="outlined" onClick={() => navigate("/inventory")}>
          Inventory
        </Button>
        <Button
          variant="outlined"
          onClick={() => navigate("/inventory/archive")}
        >
          Archive
        </Button>
        <Button
          variant="outlined"
          onClick={() => navigate("/inventory/history")}
        >
          History
        </Button>
      </Box>
    </Box>
  );
};

export default InventoryHero;
